import TagManager from 'react-gtm-module';

export function initGTM(): void {
	if (process.env.REACT_APP_GTM_ID) {
		const tagManagerArgs = {
			gtmId: process.env.REACT_APP_GTM_ID,
		};
		TagManager.initialize(tagManagerArgs);
	}
}
